import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable no-useless-computed-key */import React, { Component } from 'react';
import styled from 'styled-components';
import withMatch from '@/hocs/withMatch';
import BBCode from '../../richText/BBCode';
import withApiData from '../../../../services/withApiData';
var connectApiData = withApiData({
  profile: 'getProfile'
}, function (ownProps) {
  return {
    profile: {
      projectSlug: ownProps.match.params.projectSlug
    }
  };
});
var Users = /*#__PURE__*/function (_Component) {
  function Users() {
    var _this;
    _classCallCheck(this, Users);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Users, [].concat(args));
    _defineProperty(_this, "sortArray", function (profileData) {
      if (!profileData || !profileData.customer || !profileData.customer.users) return [];

      // We want to order the array of users, so the logged in user is first, then the other users in the household.
      return profileData.customer.users.sort(function (user) {
        return user.email === profileData.email ? 0 : 1;
      });
    });
    return _this;
  }
  _inherits(Users, _Component);
  return _createClass(Users, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        profile = _this$props.profile,
        link = _this$props.link;
      var userListContent = profile.data ? this.sortArray(profile.data).map(function (user, index) {
        return "[li]".concat(user.name, " - ").concat(user.email, "[/li]");
      }).join('') : null;
      var content = {
        content: "\n        ".concat(userListContent ? "[olist]".concat(userListContent, "[/olist]") : '', "\n        ").concat(link && link.link ? "[pagenode=\"0\" type=\"link\"]".concat(link.label, "[/pagenode]") : '', "\n        "),
        pages: link && link.link ? _defineProperty({}, 0, link.link) : {}
      };
      return content ? __jsx(Container, {
        "data-id": "fieldTypes_Users_Container"
      }, __jsx(BBCode, {
        content: content,
        "data-id": "fieldTypes_Users_BBCode"
      })) : null;
    }
  }]);
}(Component);
export default withMatch(connectApiData(Users));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: -30rem;\n  > div {\n    margin-top: -30rem;\n  }\n"])));